import {
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { setMiniSidenav, useMaterialUIController } from "./context";
import { useContext, useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import routes from "./routes";
import logo from "../src/assest/images/logo.jpg";
import { filterRoutes } from "./pages/Utils/filterRoutes";
import { UserContext } from "./pages/usercontext/usercontext";

function App() {
  const { user } = useContext(UserContext);
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const accessData = user?.permission; //role permission

  // Filter the routes
  const filteredRoutes = filterRoutes(routes, accessData);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" &&
        pathname !== "/forget-password" &&
        pathname !== "/otp-verify" &&
        pathname !== "/confirm-password" &&
        pathname !== "/reset-successful" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={logo}
              mininav={miniSidenav}
              brandName="Keelis"
              routes={filteredRoutes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
          </>
        )}

      <Routes>
        {user
          ? getRoutes(routes) //User is logged in — allow full access
          : getRoutes(
              routes.filter((route) => route.name === "Authentication") //User Not login Only allow authentication routes
            )}

        {/* Fallback: redirect all unknown paths to sign-in */}
        <Route path="*" element={<Navigate to="/sign-in" />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
